/**
 * Which flows belong on a surface that is filtered to the active workspaces.
 * Same rule as the Flows sidebar: a hop-studios path stays out of Kootenay
 * Lightweb. Root platform/ flows have no workspace prefix and stay visible.
 */

export function flowMatchesWorkspaceScope(
  filePath: string | undefined | null,
  folderPaths: string[],
): boolean {
  const fp = (filePath ?? '').trim().replace(/^\/+/, '')
  if (!fp) return true
  if (fp.startsWith('platform/')) return true
  if (folderPaths.length === 0) return true
  return folderPaths.some((root) => {
    const normalized = root.replace(/\/+$/, '')
    if (!normalized) return false
    return fp === normalized || fp.startsWith(`${normalized}/`)
  })
}
